import { LANGUAGE_OPTIONS } from "../usePatientForm";
import ParentsFields from "./ParentsFields";
import EmergencyContactFields from "./EmergencyContactFields";

/**
 * פרטים נוספים — personal details, contact info, emergency contact and
 * parents. Everything here is optional.
 */
function DetailsStep({ form }) {
  const {
    formData,
    handleChange,
    handleNestedChange,
    handleLanguageToggle,
    formatIdNumber,
    isSpeechTherapist,
  } = form;

  const emailField = (
    <div className="form-group">
      <label>אימייל</label>
      <input
        type="email"
        value={formData.email}
        onChange={(e) => handleChange("email", e.target.value)}
        placeholder="email@example.com"
        dir="ltr"
      />
    </div>
  );

  return (
    <div className="pat-wiz-step-panel" key="step-details">
      <h3 className="section-title">פרטים אישיים</h3>

      {/* Couple patients: partner ID numbers are edited in the basic step;
          the top-level idNumber is denormalized from the primary partner.
          Email pairs with the ID field; for couples it renders full-width. */}
      {!formData.isCouple ? (
        <div className="form-row">
          <div className="form-group">
            <label>תעודת זהות</label>
            <input
              type="text"
              value={formData.idNumber}
              onChange={(e) =>
                handleChange("idNumber", formatIdNumber(e.target.value))
              }
              placeholder="9 ספרות"
              dir="ltr"
            />
          </div>
          {emailField}
        </div>
      ) : (
        emailField
      )}

      <div className="form-group">
        <label>שפות</label>
        <div className="language-chips">
          {LANGUAGE_OPTIONS.map((lang) => {
            const isSelected = formData.languages.includes(lang);
            return (
              <button
                key={lang}
                type="button"
                aria-pressed={isSelected}
                className={`language-chip ${isSelected ? "selected" : ""}`}
                onClick={() => handleLanguageToggle(lang)}
              >
                {lang}
              </button>
            );
          })}
        </div>
      </div>

      <h3 className="section-title">פרטי התקשרות</h3>

      <div className="form-row three-cols">
        <div className="form-group">
          <label>עיר</label>
          <input
            type="text"
            value={formData.address.city}
            onChange={(e) =>
              handleNestedChange("address", "city", e.target.value)
            }
            placeholder="עיר"
          />
        </div>
        <div className="form-group">
          <label>רחוב</label>
          <input
            type="text"
            value={formData.address.street}
            onChange={(e) =>
              handleNestedChange("address", "street", e.target.value)
            }
            placeholder="רחוב"
          />
        </div>
        <div className="form-group">
          <label>מספר</label>
          <input
            type="text"
            value={formData.address.number}
            onChange={(e) =>
              handleNestedChange("address", "number", e.target.value)
            }
            placeholder="מס׳"
            dir="ltr"
          />
        </div>
      </div>

      <EmergencyContactFields form={form} />

      {/* For non-speech-therapist clinics: parents live in this step
          (speech clinics collect them in the basic step) */}
      {!isSpeechTherapist && (
        <>
          <ParentsFields form={form} />
          <div className="form-group">
            <label>הערות משפחתיות</label>
            <textarea
              value={formData.familyNotes}
              onChange={(e) => handleChange("familyNotes", e.target.value)}
              placeholder="למשל: הורים גרושים, לשלוח חשבונית לשניהם..."
              rows={3}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default DetailsStep;
